import { useCallback } from 'react';
import { toast as sonnerToast } from 'sonner';

export interface Toast {
  id: string;
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive';
}

/**
 * API antiga mantida para os ~80 componentes que já usam `useToast()`,
 * agora renderizada pelo Sonner (um único Toaster, acima dos modais).
 */
export function useToast() {
  const toast = useCallback(({ title, description, variant = 'default' }: Omit<Toast, 'id'>) => {
    const id =
      variant === 'destructive'
        ? sonnerToast.error(title || 'Erro', { description })
        : sonnerToast.success(title || description || '', {
            description: title ? description : undefined,
          });
    return { id: String(id) };
  }, []);

  const dismiss = useCallback((id?: string) => {
    sonnerToast.dismiss(id);
  }, []);

  return { toast, dismiss };
}
